module.exports = __webpack_public_path__ + "img/offer4.088284fd.png";